export default [
    {
        path: "/wholefamily/familydetail/:item_sub_id/:sports_id",
        name: "familydetail",
        props:true,
        component: () => import(/* webpackChunkName: "activity" */"../views/WholeFamily/Detail/index.vue"),
        meta: {
            title: "全家总动员",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/wholefamily/familyrecord",
        name: "familyrecord",
        component: () => import(/* webpackChunkName: "Orient" */"../views/WholeFamily/Record/index.vue"),
        meta: {
            title: "我的视频",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/wholefamily/vote/:item_sub_id/:sports_id",
        name: "vote",
        props:true,
        component: () => import(/* webpackChunkName: "Orient" */"../views/WholeFamily/Vote/index.vue"),
        meta: {
            title: "我要投票",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/wholefamily/video/:mediaurl/:imgurl",
        name: "video",
        component: () => import(/* webpackChunkName: "Orient" */"../views/WholeFamily/Video/index.vue"),
        meta: {
            title: "健步走",
            showloading: true,
            requiresAuth: true
        }
    }
];
